const TYPE = "application/x-loreright-songs";

export const startDrag = (e, paths, label) => {
  e.dataTransfer.setData(TYPE, JSON.stringify(paths));
  e.dataTransfer.setData("text/plain", label || `${paths.length} songs`);
  e.dataTransfer.effectAllowed = "copy";
};

export const hasSongs = (e) => e.dataTransfer.types.includes(TYPE);

export const readDrag = (e) => {
  try { return JSON.parse(e.dataTransfer.getData(TYPE) || "[]"); } catch { return []; }
};
